export const QA_NAME_LINK_REQUESTS_ACTION = 'link_requests'
